import axios from "axios";
import axiosRetry from 'axios-retry';
let _axios
export const initialize = tenantId => {
    if (!tenantId) {
        throw new Error('Tenant id not found');
    }
    if (!_axios) {
        _axios = axios.create({
            headers: {
                'x-tenant': tenantId
            }
        });
        axiosRetry(_axios, { retries: 5, retryDelay: axiosRetry.exponentialDelay });
        window.axios = _axios;
    }
}


export default () => _axios;